function plural(count, one, many) {
    return `${count} ${count === 1 ? one : many}`;
}
/**
 * What Wright did with a pull request's review points, in one sentence. The
 * ask, the timeline and the sheet's footer all say it with these words, so the
 * same summary never reads as two different counts. A thread Proctor still
 * holds open is not counted as handled. Null when there is no summary.
 */
export function settleSummarySentence(summary) {
    if (!summary)
        return null;
    const handled = summary.fixed + summary.disputed + summary.needsPerson.length;
    const parts = [
        summary.fixed > 0 ? `${summary.fixed} fixed` : null,
        summary.disputed > 0 ? `${summary.disputed} disputed with a reply` : null,
        summary.needsPerson.length > 0 ? `${summary.needsPerson.length} left for a person` : null,
    ].filter(Boolean);
    const lines = [
        handled > 0
            ? `Wright handled ${plural(handled, "review thread", "review threads")} (${parts.join(", ")}).`
            : "Wright had no review point left to handle.",
    ];
    if (summary.disagreements.length > 0) {
        lines.push(`Proctor still holds ${plural(summary.disagreements.length, "thread", "threads")} open after Wright's answer.`);
    }
    if (summary.leftover > 0) {
        lines.push(`${plural(summary.leftover, "note stays a comment", "notes stay comments")} on the pull request.`);
    }
    return lines.join(" ");
}
//# sourceMappingURL=settleSummary.js.map